<div *ngIf="addons.length > 0" class="flex flex-wrap items-center gap-2 pt-1">
  <span class="text-xs text-gray-400 dark:text-dark-muted">{{ addLabel }}</span>
  <button *ngFor="let a of addons" type="button" (click)="activate.emit(a.key)"
    class="h-8 pl-2.5 pr-3.5 rounded-full bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border text-xs font-medium text-gray-600 dark:text-dark-muted inline-flex items-center gap-1.5 hover:text-gray-900 dark:hover:text-dark-text transition-colors">
    <span class="material-symbols-rounded text-[15px] text-gray-400">add</span>
    <span class="material-symbols-rounded text-[15px]">{{ a.icon }}</span>
    {{ a.label }}
  </button>
</div>
